var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsCompaigns01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-4 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #000;\n        stroke-width: 0.75px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-linecap: round;\n      }\n\n      .cls-4 {\n        stroke-linejoin: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ads Compaigns") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.38,10.17,12.49,14a.29.29,0,0,0,.35.09l1-.4a.31.31,0,0,0,.13-.48L11.49,9.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.45,7.7h.81a0,0,0,0,1,0,0v2.94a0,0,0,0,1,0,0H7.32a.55.55,0,0,1-.55-.55V8.37a.68.68,0,0,1,.68-.68Z",
    transform: "translate(-2.87 3.46) rotate(-21.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.79,7.45s5.31-3.68,6.12-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.86,10.25s6.55-1.07,8.06-.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.38,3.28l-.46-1.15a.47.47,0,0,1,.26-.61L15.39,1a.48.48,0,0,1,.61.26l3.16,7.87a.48.48,0,0,1-.26.61l-1.22.48a.46.46,0,0,1-.6-.26l-2.2-5.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17.98,
    y1: 3.08,
    x2: 18.86,
    y2: 2.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.15,
    y1: 6,
    x2: 20.25,
    y2: 5.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.55,
    y1: 4.51,
    x2: 20.5,
    y2: 3.73
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.14,8.91h1.75a1.7,1.7,0,0,1,1.7,1.7V21.2a1.69,1.69,0,0,1-1.7,1.69H3.48A1.69,1.69,0,0,1,1.79,21.2V10.61a1.7,1.7,0,0,1,1.69-1.7h3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "3.49 11.64 11.87 17.78 20.88 11.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "9.25 18.45 12.08 20.52 15.13 18.45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsCompaigns01);
export default __webpack_public_path__ + "static/media/Ads_Compaigns_01.8a9c44c3a3157828e863078b6ba20456.svg";
export { ForwardRef as ReactComponent };